class ColorSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('mouseover', this.handleMouseOver.bind(this));
    this.addEventListener('mouseout', this.handleMouseOut.bind(this));
    this.addEventListener('click', this.handleMouseClick.bind(this));
  }

  handleMouseOver(e) {
    const wrapper = e.target.closest('.gdl-swatch-wrapper');
    if (wrapper) {
      const related = e.relatedTarget?.closest('.gdl-swatch-wrapper');
      if (related === wrapper) return;

      const btn = wrapper.querySelector('.gdl-swatch-btn');
      if (btn) this.handleSwatchHover(btn);
    }
  }

  handleMouseOut(e) {
    const wrapper = e.target.closest('.gdl-swatch-wrapper');
    if (wrapper) {
      const relatedWrapper = e.relatedTarget?.closest('.gdl-swatch-wrapper');
      if (relatedWrapper !== wrapper) {
        const btn = wrapper.querySelector('.gdl-swatch-btn');
        if (btn) this.handleSwatchLeave(btn);
      }
    }
  }

  handleMouseClick(e) {
    const wrapper = e.target.closest('.gdl-swatch-wrapper');
    if (wrapper) {
      const btn = wrapper.querySelector('.gdl-swatch-btn');
      if (btn) this.handleSwatchClick(btn, e);
    }
  }

  getCardElements(btn) {
    const card = btn.closest('.gdl-carousel-card');
    if (!card) return null;
    const imgWrapper = card.querySelector('.gdl-card-image');
    const picture = imgWrapper ? imgWrapper.querySelector('picture') : null;
    const img = imgWrapper ? imgWrapper.querySelector('img') : null;
    return {
      card,
      imgWrapper,
      picture,
      image: img,
      title: card.querySelector('.gdl-card-title'),
      price: card.querySelector('.gdl-card-price'),
      links: card.querySelectorAll('.gdl-card-link-product'),
      badge: card.querySelector('.gdl-card-badge')
    };
  }

  updateImageSafely(image, newSrc) {
    if (!image || !newSrc) return;
    if (image.src === newSrc) return;
    image.dataset.pendingSrc = newSrc;
    const loader = new Image();
    loader.onload = () => {
      if (image.dataset.pendingSrc === newSrc) {
        image.removeAttribute('srcset');
        image.src = newSrc;
        image.removeAttribute('data-pending-src');
      }
    };
    loader.src = newSrc;
  }

  handleSwatchHover(btn) {
    const els = this.getCardElements(btn);
    if (!els || !els.image) return;

    const newImage = btn.getAttribute('data-variant-image');
    const variantBadge = btn.getAttribute('data-variant-badge');

    if (newImage && newImage !== "null" && newImage !== "") {
      if (!els.image.hasAttribute('data-original-src')) {
        els.image.setAttribute('data-original-src', els.image.src);
        els.image.setAttribute('data-original-srcset', els.image.srcset || '');
      }

      if (els.picture) {
        const sources = els.picture.querySelectorAll('source');
        sources.forEach(source => {
          if (!source.hasAttribute('data-original-srcset')) {
            source.setAttribute('data-original-srcset', source.srcset);
          }
          source.srcset = '';
        });
      }

      this.updateImageSafely(els.image, newImage);
    }

    if (variantBadge && variantBadge !== "null" && els.badge) {
      if (!els.badge.hasAttribute('data-original-badge')) {
        els.badge.setAttribute('data-original-badge', els.badge.innerHTML);
      }
      els.badge.innerHTML = variantBadge;
    }
  }

  handleSwatchLeave(btn) {
    const els = this.getCardElements(btn);
    if (!els) return;

    if (els.image) {
      const currentBaseSrc = els.image.getAttribute('data-base-src');
      let targetSrc = null;

      if (currentBaseSrc) {
        targetSrc = currentBaseSrc;
      } else {
        const originalSrc = els.image.getAttribute('data-original-src');
        if (originalSrc) {
          targetSrc = originalSrc;
        }
      }
      if (targetSrc) {
        this.updateImageSafely(els.image, targetSrc);
      }
    }

    if (els.badge) {
      const currentBaseBadge = els.badge.getAttribute('data-base-badge');
      const originalBadge = els.badge.getAttribute('data-original-badge');
      if (currentBaseBadge) {
        els.badge.innerHTML = currentBaseBadge;
      } else if (originalBadge) {
        els.badge.innerHTML = originalBadge;
      }
    }
  }

  handleSwatchClick(btn, e) {
    e.preventDefault();
    e.stopPropagation();

    const els = this.getCardElements(btn);
    if (!els) return;

    const allSwatches = this.querySelectorAll('.gdl-swatch-btn');
    allSwatches.forEach(s => {
      const line = s.parentElement.querySelector('div');
      if (line) {
        line.classList.remove('opacity-100', 'gdl-swatch-active-line');
        line.classList.add('opacity-0', 'group-hover/swatch:opacity-100');
      }
    });

    const activeLine = btn.parentElement.querySelector('div');
    if (activeLine) {
      activeLine.classList.remove('opacity-0', 'group-hover/swatch:opacity-100');
      activeLine.classList.add('opacity-100', 'gdl-swatch-active-line');
    }

    const variantUrl = btn.getAttribute('data-variant-url');
    const variantTitle = btn.getAttribute('data-variant-title');
    const variantPrice = btn.getAttribute('data-variant-price');
    const variantImage = btn.getAttribute('data-variant-image');
    const variantBadge = btn.getAttribute('data-variant-badge');

    if (els.image && variantImage && variantImage !== "null") {
      els.image.setAttribute('data-base-src', variantImage);
      els.image.removeAttribute('srcset');
      els.image.removeAttribute('data-base-srcset');

      this.updateImageSafely(els.image, variantImage);
    }

    if (els.badge && variantBadge && variantBadge !== "null") {
      els.badge.setAttribute('data-base-badge', variantBadge);
      els.badge.innerHTML = variantBadge;
    }

    if (variantUrl) {
      els.links.forEach(link => {
        link.href = variantUrl;
      });
    }

    if (variantTitle && els.title) {
      els.title.textContent = variantTitle;
    }

    if (variantPrice && els.price) {
      els.price.innerHTML = variantPrice;
    }
  }
}

customElements.define('color-swatches', ColorSwatches);
